import { Message } from "primereact/message";

interface IErrorLoading  {
  message:string
}

const ErrorSourceExterne = ({message}:IErrorLoading) => {
    return (
        <>
    <div className="contentForm">
      <div className="formSourceExt mr-5">
        <div className="m-5">
          <Message
            className="w-full"
            severity="error"
            text={message}   />
        </div>
      </div>
    </div>
  </>
    )
  
};


export default ErrorSourceExterne